"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientOutsideDoctor_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ReferralSource_1 = require("./ReferralSource");
var PatientOutsideDoctor_Factory = /** @class */ (function () {
    function PatientOutsideDoctor_Factory() {
    }
    PatientOutsideDoctor_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            IsPrimary: model.IsPrimary,
            OutsideDoctorDate: Date_Factory_1.Date_Factory.CreateIncoming(model.OutsideDoctorDate),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ReferralSource: ReferralSource_1.ReferralSource_Factory.CreateIncoming(model.ReferralSource),
            ReferralSourceId: model.ReferralSourceId,
        };
        return result;
    };
    PatientOutsideDoctor_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            IsPrimary: model.IsPrimary,
            OutsideDoctorDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.OutsideDoctorDate),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ReferralSource: ReferralSource_1.ReferralSource_Factory.CreateOutgoing(model.ReferralSource),
            ReferralSourceId: model.ReferralSourceId,
        };
        return result;
    };
    return PatientOutsideDoctor_Factory;
}());
exports.PatientOutsideDoctor_Factory = PatientOutsideDoctor_Factory;
